import React from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { useNavigate } from 'router'
import { ResponsiveSideContent } from 'components-shared'
import CardDetails from './CardDetails'

const Card: React.FC = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const handleClose = () => navigate({ pathname: '..' })

  return (
    <ResponsiveSideContent onClose={handleClose} style={{ overflow: 'hidden' }}>
      {id && <CardDetails id={id} />}
      <Outlet />
    </ResponsiveSideContent>
  )
}

export default Card
